import React from 'react';
import banner from '../images/camp_banner.png';
import { Link, withRouter } from "react-router-dom";
import {
  Baseball,
  Basketball,
  Football,
  Golf,
  Lacrosse,
  Soccer,
  Softball,
  Swimming,
  Volleyball,
  Wrestling
} from '../images/icons';

function Home() {
  return (
    <div className="home">
      <div className="row">
        <div className="position-relative">
          <img className="mx-auto d-block" alt="Student Athlete Camps Banner" src={banner} />
          <div class="bottom-left">
            <h1 className="text-left banner-text">PLAY.</h1>
            <h1 className="text-left banner-text">LEARN.</h1>
            <h1 className="text-left banner-text">GROW.</h1>
            </div>
        </div>
      </div>
      <div className="row">
        <div className="container no-padding">
          <div className="row">
            <div className="col-12">
              <h1 className="mx-auto mt-4">FIND A CAMP</h1>
            </div>
            <div className="col-12">
              <p className="mx-auto">Select a sport to find a camp today!</p>
            </div>
          </div>
          <div className="row">
            <div className="row justify-content-center pl-5 pr-5">
            <div className="col-0 col-sm-0	col-md-1	col-lg-1	col-xl-1	col-xxl-1">

            </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=baseball">
                <img className="mx-auto d-block" alt="Baseball Events Link Icon" src={Baseball} />
                <h5 className="mt-2">BASEBALL</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=basketball">
                <img className="mx-auto d-block" alt="Basketball Events Link Icon" src={Basketball} />
                <h5 className="mt-2">BASKETBALL</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=football">
                <img className="mx-auto d-block" alt="Football Events Link Icon" src={Football} />
                <h5 className="mt-2">FOOTBALL</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=golf">
                <img className="mx-auto d-block" alt="Golf Events Link Icon" src={Golf} />
                <h5 className="mt-2">GOLF</h5>
                </Link>
              </div>


              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=lacrosse">
                <img className="mx-auto d-block" alt="Lacrosse Events Link Icon" src={Lacrosse} />
                <h5 className="mt-2">LACROSSE</h5>
                </Link>
              </div>
              <div className="d-sm-none d-none d-md-block col-md-1	col-lg-1	col-xl-1	col-xxl-1">

              </div>
              <div className="d-sm-none d-none  d-md-block col-md-1	col-lg-1	col-xl-1	col-xxl-1">

</div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=soccer">
                <img className="mx-auto d-block" alt="Soccer Events Link Icon" src={Soccer} />
                <h5 className="mt-2">SOCCER</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=softball">
                <img className="mx-auto d-block" alt="Softball Events Link Icon" src={Softball} />
                <h5 className="mt-2">SOFTBALL</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=swimming">
                <img className="mx-auto my-auto d-block" alt="Swimming Events Link Icon" src={Swimming} />
                <h5 className="mt-2">SWIMMING</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=volleyball">
                <img className="mx-auto d-block" alt="Volleyball Events Link Icon" src={Volleyball} />
                <h5 className="mt-2">VOLLEYBALL</h5>
                </Link>
              </div>
              <div className="col-6 col-sm-6	col-md-2	col-lg-2	col-xl-2	col-xxl-2 p-4 align-self-center">
              <Link className="nav-link nav-link-card" to="/events?sport=wrestling">
                <img className="mx-auto d-block" alt="Wrestling Events Link Icon" src={Wrestling} />
                <h5 className="mt-2">WRESTLING</h5>
                </Link>
              </div>
              <div className="col-0 col-sm-0	col-md-1	col-lg-1	col-xl-1	col-xxl-1">

</div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <h1 className="mx-auto">OR</h1>
            </div>
            <div className="col-12">
              <p className="mx-auto">Don't see your sport? Click below to see all sports and events!</p>
            </div>
          </div>
          <div className="row">
          <Link className="mx-auto" to="/events">
            <button className="btn mx-auto  mt-4 mb-4 btn-primary d-flex" ><div className="btn-text p-2 row justify-content-center align-self-center mx-auto">ALL EVENTS</div></button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(Home);